module.exports = __webpack_public_path__ + "media/images/views/lp/client/banner-client-41307fc338241210d23b4f6284991b9c.jpg";